/* istanbul ignore file */
import { InMemoryCache } from "@apollo/client";

export const createCache = () =>
  new InMemoryCache({
    typePolicies: {
      Agent: {
        keyFields: ["ID"],
      },
      AgentV2: {
        keyFields: ["ID"],
      },
      BasicCall: {
        keyFields: ["callId"],
      },
      UpdatedTracker: {
        keyFields: ["tracker", ["trackerId"]],
      },
      Tracker: {
        keyFields: ["trackerId"],
      },
      CallConversation: {
        keyFields: ["callId"],
      },
      Company: {
        keyFields: ["ID"],
      },
      ConversationAgent: {
        keyFields: ["agentDetails", ["agentId"]],
      },
      ConversationContact: {
        keyFields: ["phoneNumber"],
      },
      Line: {
        keyFields: ["ID"],
      },
      LineSettingsOutput: {
        keyFields: ["lineID"],
      },
      LineTranscriptionSettings: {
        keyFields: ["lineId"],
      },
      ScoreCard: {
        keyFields: ["ID"],
      },
      ScoreCardCategory: {
        keyFields: ["ID"],
      },
      Evaluation: {
        keyFields: ["ID"],
      },
      EvaluationCategory: {
        keyFields: ["ID"],
      },
    },
  });
